module.exports = __webpack_public_path__ + "img/slide7.c37908b6.jpg";